import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { BooksGridSection } from './components/BooksGridSection';
import { AboutAuthorSection } from './components/AboutAuthorSection';
import { TestimonialsSection } from './components/TestimonialsSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://businessdevelopmentauthority.net';

const BooksPage: React.FC = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${SITE_URL}/books`,
        'url': `${SITE_URL}/books`,
        'name': 'Books by Jeffery Long - AI, Finance, Business & Personal Growth',
        'description': 'Explore the complete collection of books by Jeffery Long covering AI & Technology, Finance & Banking, Business Development, Real Estate, and Personal Growth.',
        'isPartOf': { '@id': SITE_URL },
      },
      {
        '@type': 'ItemList',
        'name': 'Books by Jeffery Long',
        'description': 'A comprehensive collection of books by author Jeffery Long on AI, Finance, Business Development, Real Estate, and Personal Growth.',
        'url': `${SITE_URL}/books`,
        'numberOfItems': 44,
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': 1,
            'item': {
              '@type': 'Book',
              'name': 'Mastering AI-Powered Trading Bots for Options',
              'author': { '@type': 'Person', 'name': 'Jeffery Long' },
              'url': 'https://www.amazon.com/dp/B0DLQX8QXG',
              'genre': 'AI & Technology',
            },
          },
          {
            '@type': 'ListItem',
            'position': 2,
            'item': {
              '@type': 'Book',
              'name': 'The Infinite Banking Concept',
              'author': { '@type': 'Person', 'name': 'Jeffery Long' },
              'genre': 'Finance & Banking',
            },
          },
          {
            '@type': 'ListItem',
            'position': 3,
            'item': {
              '@type': 'Book',
              'name': 'Strategic Business Development',
              'author': { '@type': 'Person', 'name': 'Jeffery Long' },
              'genre': 'Business Development',
            },
          },
        ],
      },
      {
        '@type': 'Person',
        'name': 'Jeffery Long',
        'url': 'https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5',
        'jobTitle': 'Author & AI Consultant',
        'worksFor': {
          '@type': 'Organization',
          'name': 'Business Development Authority',
          'url': SITE_URL,
        },
        'sameAs': [
          'https://www.linkedin.com/in/jeffery-long-23b02a38a/',
          'https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5',
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <BooksGridSection />
          <AboutAuthorSection />
          <TestimonialsSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default BooksPage;
